'use client'

import type { JSX } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { theme } from './theme'

export function ThemeProvider({ children }: { children }): JSX.Element {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {/* Keeps Google's Drive picker above every other element on the page. */}
      <style>{`
          body .picker-dialog-bg {
            z-index: 1000000 !important;
          }
          body .picker-dialog {
            z-index: 1000001 !important;
          }
        `}</style>
      {children}
    </MuiThemeProvider>
  )
}
